<template>
    <div class="v-count-down-digit">
        <div :style="{ transform: `translateY(${-digit}em)` }">
            <span v-for="i in 10" :key="i">{{ i - 1 }}</span>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        digit: {
            type: [String, Number],
            default: 0,
        },
    },
};
</script>

<style lang="scss" scoped>
.v-count-down-digit {
    display: inline-block;
    height: 1em;
    overflow: hidden;
    vertical-align: middle;
    line-height: 1em;

    > div {
        transition: all ease 300ms;
    }

    > div > span {
        display: block;
    }
}
</style>
